import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  CardFooter,
} from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import type { ImportResult } from '../types'
import { CircleCheck, ShieldAlert } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'

export interface BatchImportConfirmProps extends ImportResult {
  onOk?: () => void
  setOpen?: any
}

export function BatchImportConfirm(props: BatchImportConfirmProps) {
  const { total, inserted, setOpen, onOk } = props
  const t = useTranslations('database')

  const success = total > 0 && total === inserted

  const handleOk = () => {
    setOpen(false)
    onOk?.()
  }

  return (
    <Card className="w-full p-6 text-center">
      <CardHeader>
        {success ? (
          <CircleCheck className="mx-auto mb-4 h-12 w-12 text-green-500" />
        ) : (
          <ShieldAlert className="mx-auto mb-4 h-12 w-12 text-red-500" />
        )}
        <CardTitle
          className={cn({
            'text-green-500': success,
            'text-red-500': !success,
          })}
        >
          {success
            ? t('batchImportResult.import_success')
            : t('batchImportResult.partial_import_failed')}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground">
          {t('batchImportResult.summary_prefix')}{' '}
          <span className="text-brand_2">{total} </span>
          {t('batchImportResult.summary_middle')}{' '}
          <span className="text-green-500">{inserted}</span>{' '}
          {t('batchImportResult.summary_suffix')}
          {!success && (
            <span className="text-red-500">
              {t('batchImportResult.failed_prefix')} {total - inserted}{' '}
              {t('batchImportResult.failed_suffix')}
            </span>
          )}
        </p>
      </CardContent>
      <CardFooter>
        <Button className="w-full" onClick={handleOk}>
          {t('batchImportResult.complete')}
        </Button>
      </CardFooter>
    </Card>
  )
}
